import React from 'react';
import { Select, Spin } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';
import { useGetProfilesOfVM } from 'query/enoch';

const SelectProfiles = ({ vm }) => {
  const { control } = useFormContext();
  const { data, isFetching } = useGetProfilesOfVM(vm);

  return (
    <Spin spinning={isFetching}>
      <Controller
        control={control}
        name="profiles"
        render={({ field }) => {
          return (
            <Select
              mode="multiple"
              placeholder="Select profiles to run or leave empty to run all profiles"
              style={{ width: '100%' }}
              value={field.value}
              onBlur={field.onBlur}
              onChange={v => field.onChange(v)}
            >
              {data.map(d => (
                <Select.Option key={d.profile} value={d.profile}>
                  {d.profile} {d.email ? `(${d.email})` : ''}
                </Select.Option>
              ))}
            </Select>
          );
        }}
      />
    </Spin>
  );
};

export default SelectProfiles;
